



































import {Component, PropSync} from "vue-property-decorator";
import {Action, Mutation} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {DatePickerWings, FastDateGroupWings, FilterWings, SelectWings, FilterSelectedItemWings} from "wings-ui-components";
import {SummaryFilter} from "@/store/reports/types";
import {currentDay, onlyDateFilter} from "@/utils/date-util";
import {notifyError, notifySuccess, notifyWarning} from '@/utils/notify-helper';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {
    DatePickerWings,
    FastDateGroupWings,
    FilterSelectedItemWings,
    FilterWings,
    SelectWings,
  },
  filters: {
    onlyDateFilter
  }
})
export default class SummaryGroupFilter extends BaseFilter<SummaryFilter> {
  @PropSync('show') is_show!: boolean;

  @Mutation('setSummaryGroup') setStatistic: any

  @Action("getSummaryGroup") actionGetItems: any;
  @Action("exportSummaryStatisticGroup") actionExport: any;
  @Action("actionLog") actionLog: any;

  defaultFilter():SummaryFilter {
    return {
      date_from: currentDay(),
      date_to: currentDay(),
      message_direction: 'mt'
    }
  }

  created() {
    this.setStatistic(null)
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Group statistics",
        addititionalInfo: getTranslatedParams(this.filter)
      }
      const resp = await this.actionGetItems(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status === 204) {
        notifyWarning()
      }
    } catch(err) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(err)
    }
  }

  // Override
  async doActionExport() {
    this.logObject = {
      actionPage: this.$route.meta.msgKey,
      action: "Export",
      actionStatus: 'success',
      objectType: "Group statistics",
      addititionalInfo: getTranslatedParams(this.filter)
    }
    try {
      await this.actionExport(this.filter);
      await this.actionLog(this.logObject)
      notifySuccess(this.$t('dialog.export').toString());
    } catch(err) {
      notifyError(err)
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

}
